let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

class B2bQuantityBreaks extends HTMLElement {
  connectedCallback() {
    this.rows = Array.from(this.querySelectorAll(".b2b-quantity-breaks__row"));
    this.quantityInput = this.resolveQuantityInput();

    this.rows.forEach((row) => {
      row.addEventListener("click", () => this.selectQuantity(row));
      row.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.selectQuantity(row);
        }
      });
    });

    if (this.quantityInput) {
      this.onQuantityChange = this.syncFromInput.bind(this);
      this.quantityInput.addEventListener("change", this.onQuantityChange);
      this.quantityInput.addEventListener("input", this.onQuantityChange);
      this.syncFromInput();
    }
  }

  disconnectedCallback() {
    if (this.quantityInput && this.onQuantityChange) {
      this.quantityInput.removeEventListener("change", this.onQuantityChange);
      this.quantityInput.removeEventListener("input", this.onQuantityChange);
    }
  }

  resolveQuantityInput() {
    const section =
      this.closest(".shopify-section") || this.closest("[id^=shopify-section]") || document;
    return section.querySelector("quantity-counter:not([data-cart]) .js-counter-quantity");
  }

  selectQuantity(row) {
    const quantity = parseInt(row.dataset.qbQuantity, 10);
    if (!this.quantityInput || Number.isNaN(quantity)) return;

    this.quantityInput.value = quantity;
    this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    this.highlight(quantity);
  }

  syncFromInput() {
    const current = parseInt(this.quantityInput.value, 10);
    if (Number.isNaN(current)) return;
    this.highlight(current);
  }

  // Active tier = highest threshold that is <= current quantity
  highlight(quantity) {
    let activeRow = null;
    this.rows.forEach((row) => {
      const threshold = parseInt(row.dataset.qbQuantity, 10);
      if (threshold <= quantity && (!activeRow || threshold > parseInt(activeRow.dataset.qbQuantity, 10))) {
        activeRow = row;
      }
    });

    this.rows.forEach((row) => {
      const isActive = row === activeRow;
      row.classList.toggle("is-selected", isActive);
      row.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }
}

window.customElements.define("b2b-quantity-breaks", B2bQuantityBreaks);

class B2cBundles extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll(".b2c-bundles__option"));
    this.quantityInput = this.resolveQuantityInput();

    this.options.forEach((option) => {
      option.addEventListener("click", () => this.selectQuantity(option));
    });

    if (this.quantityInput) {
      this.onQuantityChange = this.syncFromInput.bind(this);
      this.quantityInput.addEventListener("change", this.onQuantityChange);
      this.quantityInput.addEventListener("input", this.onQuantityChange);
      this.syncFromInput();
    }
  }

  disconnectedCallback() {
    if (this.quantityInput && this.onQuantityChange) {
      this.quantityInput.removeEventListener("change", this.onQuantityChange);
      this.quantityInput.removeEventListener("input", this.onQuantityChange);
    }
  }

  resolveQuantityInput() {
    const section =
      this.closest(".shopify-section") || this.closest("[id^=shopify-section]") || document;
    return section.querySelector("quantity-counter:not([data-cart]) .js-counter-quantity");
  }

  selectQuantity(option) {
    const quantity = parseInt(option.dataset.b2cQuantity, 10);
    if (!this.quantityInput || Number.isNaN(quantity)) return;

    this.quantityInput.value = quantity;
    this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    this.highlight(quantity);
  }

  syncFromInput() {
    const current = parseInt(this.quantityInput.value, 10);
    if (Number.isNaN(current)) return;
    this.highlight(current);
  }

  // Active option = highest bundle size that is <= current quantity
  highlight(quantity) {
    let activeOption = null;
    this.options.forEach((option) => {
      const size = parseInt(option.dataset.b2cQuantity, 10);
      if (size <= quantity && (!activeOption || size > parseInt(activeOption.dataset.b2cQuantity, 10))) {
        activeOption = option;
      }
    });

    this.options.forEach((option) => {
      const isActive = option === activeOption;
      option.classList.toggle("is-selected", isActive);
      option.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }
}

window.customElements.define("b2c-bundles", B2cBundles);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

if (!customElements.get("localization-switcher")) {
  class LocalizationSwitcher extends HTMLElement {
    constructor() {
      super();

      // Reference to the dropdown element
      this.dropdown = this.querySelector("[data-dropdown]");

      this.searchInput = this.querySelector("[data-country-search]");

      // Add click event listener to toggle the dropdown
      this.addEventListener("click", (event) => {
        // Clicks into the country search must not close the dropdown
        if (event.target.closest(".localization-switcher__search")) return;

        const header = document.querySelector("bene-header");
        if (header.isDesktopMegaMenuToggled()) {
          header.toggleDesktopMegaMenu();
        }
        this.toggleAttribute("data-open"); // Toggle the 'data-open' attribute on the component
        this.dropdown.toggleAttribute("data-open"); // Toggle the 'data-open' attribute on the dropdown

        if (this.dataset.type === "country" && this.hasAttribute("data-open")) {
          // On phones the dropdown is pinned to the viewport, just below the button
          const buttonRect = this.querySelector("[data-button]").getBoundingClientRect();
          this.dropdown.style.setProperty("--dropdown-top", `${buttonRect.bottom + 16}px`);
        }

        if (this.searchInput && this.hasAttribute("data-open")) {
          this.searchInput.focus({ preventScroll: true });
        }
      });

      if (this.dataset.type === "country") {
        this.setupCountrySearch();
      }

      if (this.dataset.type === "language") {
        this.querySelectorAll(".localization-switcher__item").forEach(
          (langSwitch) => {
            langSwitch.addEventListener("click", () => {
              this.setLanguage(langSwitch.dataset.locale);
            });
          },
        );

        const languageLabelEl = this.querySelector(
          ".localization-switcher__button span",
        );
        function updateLabelToWeglotLang() {
          if (languageLabelEl) {
            languageLabelEl.textContent = Weglot.getCurrentLang().toUpperCase();
          }
        }

        updateLabelToWeglotLang();

        Weglot.on("languageChanged", () => {
          updateLabelToWeglotLang();
        });
      }

      // Add a global click listener to handle clicks outside the component
      document.addEventListener("click", this.handleOutsideClick.bind(this));
    }

    setupCountrySearch() {
      const button = this.querySelector("[data-button]");
      const countries = Array.from(this.querySelectorAll("[data-country]"));
      const noResults = this.querySelector("[data-no-results]");
      const normalize = (value) =>
        value
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      button?.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          button.click();
        }
      });

      this.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.hasAttribute("data-open")) {
          this.removeAttribute("data-open");
          this.dropdown.removeAttribute("data-open");
          button?.focus();
        }
      });

      if (!this.searchInput) return;

      this.searchInput.addEventListener("input", () => {
        const query = normalize(this.searchInput.value.trim());
        let visible = 0;
        countries.forEach((country) => {
          const match =
            !query || normalize(country.dataset.searchTerms).includes(query);
          country.hidden = !match;
          if (match) visible += 1;
        });
        if (noResults) noResults.hidden = visible > 0;
      });

      // Enter picks the first match instead of submitting the form's first button
      this.searchInput.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;
        event.preventDefault();
        countries.find((country) => !country.hidden)?.click();
      });
    }

    // Handle clicks outside the component to close the dropdown
    handleOutsideClick(event) {
      if (!this.contains(event.target)) {
        this.removeAttribute("data-open"); // Remove 'data-open' attribute from the component
        this.dropdown.removeAttribute("data-open"); // Remove 'data-open' attribute from the dropdown
      }
    }

    // Cleanup event listeners when the component is removed from the DOM
    disconnectedCallback() {
      document.removeEventListener("click", this.handleOutsideClick.bind(this));
    }

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    // Sets the language using Shopify Market, then this information is going to be picked up via JS
    async setLanguage(languageCode) {
      Weglot.switchTo(languageCode.toLowerCase());
      return;
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/localization";

      const fields = {
        language_code:
          languageCode.toUpperCase() === "DE" ? null : languageCode,
        form_type: "localization",
        _method: "put",
        utf8: "✓",
      };

      for (const name in fields) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = fields[name];
        form.appendChild(input);
      }

      document.body.appendChild(form);
      form.submit();
    }
  }

  customElements.define("localization-switcher", LocalizationSwitcher);
}

class BeneCollapsible extends HTMLElement {
  constructor() {
    super();

    this.openButton = this.querySelector(".bene-collapsible__head");
    this.content = this.querySelector(".bene-collapsible__content");
    this.icon = this.querySelector(".bene-collapsible__icon");
    this.iconHome = this.icon ? this.icon.parentElement : null;

    this.openButton.addEventListener("click", (e) => {
      // ignore clicks that originated on the moved-out icon (handled separately)
      if (
        this.icon &&
        this.icon.contains(e.target) &&
        !this.openButton.contains(this.icon)
      )
        return;
      this.toggle();
    });

    this.icon?.addEventListener("click", (e) => {
      if (this.openButton.contains(this.icon)) return; // head will handle it
      e.stopPropagation();
      this.toggle();
    });

    this.syncIconPosition();
  }

  toggle() {
    const isExpanded = this.openButton.getAttribute("aria-expanded") === "true";
    const newExpandedValue = !isExpanded;
    if (newExpandedValue) {
      this.closeAllCollapsiblesGromGroup();
    }
    this.openButton.setAttribute("aria-expanded", newExpandedValue);
    this.syncIconPosition();
  }

  syncIconPosition() {
    if (!this.icon || !this.iconHome) return;
    if (!this.iconHome.contains(this.icon))
      this.iconHome.appendChild(this.icon);
  }

  closeAllCollapsiblesGromGroup() {
    Array.from(this.parentElement.querySelectorAll("bene-collapsible"))
      .filter((collapsible) => collapsible != this)
      .forEach((collapsible) => {
        collapsible
          .querySelector(".bene-collapsible__head")
          .setAttribute("aria-expanded", false);
        if (typeof collapsible.syncIconPosition === "function") {
          collapsible.syncIconPosition();
        }
      });
  }
}

customElements.define("bene-collapsible", BeneCollapsible);
